import type { CompanyDetail, Dashboard } from "@app/shared";
import { api, qs } from "../../lib/api";

interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export const adminApi = {
  dashboard: () => api.get<Dashboard>("/admin/dashboard"),
  listCompanies: (status?: string, page?: number) =>
    api.get<Paged<CompanyDetail>>(`/admin/companies${qs({ status, page })}`),
  approveCompany: (id: string) => api.post<CompanyDetail>(`/admin/companies/${id}/approve`),
  rejectCompany: (id: string, reason?: string) =>
    api.post<CompanyDetail>(`/admin/companies/${id}/reject`, { reason }),
};
